import React from 'react'
import LazeCuttingErrorPage from './LazeCuttingErrorPage'
import '../styles/index.scss'

function LazeCuttingErrorContainer() {
    return (
        <div className='LazeCuttingErrorContainer'>
            <LazeCuttingErrorPage />
        </div>
    )
}

export default LazeCuttingErrorContainer